import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NosotrosComponent } from '../nosotros/nosotros.component';
import { MusicaComponent } from '../musica/musica.component';
import { ContactoComponent } from '../contacto/contacto.component';
import { GaleriaComponent } from '../galeria/galeria.component';
import { FooterComponent } from '../footer/footer.component';


@Component({
  selector: 'app-home',
  imports: [CommonModule, NosotrosComponent, MusicaComponent,GaleriaComponent,ContactoComponent],  // Importa CommonModule para usar *ngFor
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent  {

   upcomingShows = [
    { date: '09/03/2025', city: 'Buenos Aires (Museo Guillermo E. Hudson, Fcio Varela)', link: 'https://www.instagram.com/tropillerosoficial/reel/DHq-pPMue7c/',type: 'info' },
    { date: '03/05/2025', city: 'Quilmes (Teatro Cervantes) - Comprá tu entrada', link: 'https://www.plateanet.com/obra/30782?obra=TROPILLEROS---VIAJE&paso=inicio',type: 'buy' },

  ];
  
    galleryImages = [
      'assets/img/gallery/gallery1.jpg',
      'assets/img/gallery/gallery2.jpg',
      'assets/img/gallery/gallery3.jpg'
    ];

    socialLinks = [
      { name: 'Instagram', link: 'https://www.instagram.com/tropillerosoficial/', icon: 'fab fa-instagram', class: 'instagram' },
      { name: 'Facebook', link: 'https://es-la.facebook.com/TropillerosOficial/', icon: 'fab fa-facebook', class: 'facebook' },
      { name: 'Spotify', link: 'https://open.spotify.com/intl-es/artist/2yRSIO9AuKlZHOwK5StQEx', icon: 'fab fa-spotify', class: 'spotify' },
      { name: 'YouTube', link: 'https://www.youtube.com/c/tropillerosoficial', icon: 'fab fa-youtube', class: 'youtube' }
    ];
    
  }

